import { render, staticRenderFns } from "./comment.component.vue?vue&type=template&id=67c16274&scoped=true"
import script from "./comment.component.vue?vue&type=script&lang=js"
export * from "./comment.component.vue?vue&type=script&lang=js"
import style0 from "./comment.component.vue?vue&type=style&index=0&id=67c16274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c16274",
  null
  
)

export default component.exports